module.exports = __webpack_public_path__ + "6b9d7c90a6ec4b0e84a2a5e1d48a7365.svg";